import React, { ComponentProps, FunctionComponent } from "react";

const ObjectionsIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 14",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M10.6667 0H1.33333C0.596954 0 0 0.596954 0 1.33333V10.6667C0 11.403 0.596954 12 1.33333 12H4.66662L5.99985 14L7.33328 12H10.6667C11.403 12 12 11.403 12 10.6667V1.33333C12 0.596954 11.403 0 10.6667 0ZM4.93938 6.00004L2.89828 3.95894L3.95894 2.89828L6.00004 4.93938L8.04114 2.89828L9.1018 3.95894L7.0607 6.00004L9.1018 8.04114L8.04114 9.1018L6.00004 7.0607L3.95894 9.1018L2.89828 8.04114L4.93938 6.00004Z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd",
    })
  );
};

const ForwardRef = React.forwardRef(ObjectionsIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
